import loadable from '@loadable/component';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { NodeViewRendererProps, NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

const CollapsibleListRenderer: FC<NodeViewRendererProps> = ({ node, ...props }) => {
  const CollapsibleList = useMemo(
    () =>
      loadable(
        () => import(/* webpackChunkName: "ricos_plugin_collapsibleList" */ './collapsibleList')
      ),
    []
  );
  return <CollapsibleList key={node.id} node={node} {...props} />;
};

const CollapsibleListLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleListRenderer key={node.id} node={node} {...props} />;
};

const CollapsibleListItemRenderer: FC<NodeViewRendererProps> = ({ node, ...props }) => {
  const CollapsibleListItem = useMemo(
    () =>
      loadable(
        () =>
          import(/* webpackChunkName: "ricos_plugin_collapsibleListItem" */ './collapsibleListItem')
      ),
    []
  );
  return <CollapsibleListItem key={node.id} node={node} {...props} />;
};

const CollapsibleListItemLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleListItemRenderer key={node.id} node={node} {...props} />;
};

const CollapsibleItemPropertyRenderer: FC<NodeViewRendererProps & { type: 'title' | 'body' }> = ({
  node,
  type,
  ...props
}) => {
  const CollapsibleItemProperty = useMemo(
    () =>
      loadable(
        () =>
          import(
            /* webpackChunkName: "ricos_plugin_collapsibleListPropertyRenderer" */ './collapsibleItemProperty'
          )
      ),
    []
  );
  return <CollapsibleItemProperty key={node.id} node={node} {...props} type={type} />;
};

const CollapsibleItemTitlePropertyLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleItemPropertyRenderer key={node.id} node={node} {...props} type="title" />;
};

const CollapsibleItemBodyPropertyLoadable = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleItemPropertyRenderer key={node.id} node={node} {...props} type="title" />;
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleListLoadable,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItemLoadable,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleItemTitlePropertyLoadable,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleItemBodyPropertyLoadable,
};
